module.exports = __webpack_public_path__ + "media/images/activate/software-advice-9487893321f2beab72c5d6968eccb7d3.png";